import React from "react";
import { useAuth } from "../../auth/useAuth.js";

function fmt(n) {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (!Number.isFinite(num)) return "—";
  return new Intl.NumberFormat("en-US").format(num);
}

export default function UserLimits() {
  const { user } = useAuth();
  const limits = user?.limits;

  const items = [
    { id: "bidLimit", label: "Max bid per lot (USD)", value: limits?.bidLimit },
    { id: "bidCtyLimit", label: "Bids qty limit", value: limits?.bidCtyLimit, used: limits?.bidCount },
    { id: "payLimit", label: "Purchase cars limit", value: limits?.payLimit, used: limits?.payCount },
    { id: "activeBidsSumLimit", label: "Active bids sum (USD)", value: limits?.activeBidsSumLimit, used: limits?.activeBidsSum },
  ];

  return (
    <div className="card">
      <div className="card__title">User limits</div>
      <div className="grid grid-4">
        {items.map((it) => (
          <div key={it.id} className="stat">
            <div className="stat__label">{it.label}</div>
            <div className="stat__value">{fmt(it.value)}</div>
            {it.used !== undefined && (
              <div className="stat__sub">
                used: <b style={{ color: "var(--color-text)" }}>{fmt(it.used)}</b>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
